// Phase 9.2 — /tools/fnb-po/pos/new. Two-tile flow chooser.

import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

export default function FnbPoNewPO() {
  return (
    <div className="space-y-6" data-testid="fnb-po-new-chooser">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Create a Purchase Order</h1>
        <p className="text-sm text-muted-foreground">
          Pick a starting point.
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2">
        <Link
          to="/tools/fnb-po/pos/auto"
          data-testid="chooser-auto"
          className="group"
        >
          <Card className="hover:border-primary/60 hover:shadow-sm transition h-full">
            <CardContent className="pt-6 space-y-2">
              <div className="text-xs uppercase tracking-wider text-primary font-medium">
                Recommended
              </div>
              <div className="text-lg font-semibold">Auto-suggest from Reorder</div>
              <p className="text-sm text-muted-foreground">
                Pick a scope + status filter. We&apos;ll compute needed
                quantities, choose the cheapest vendor per SKU, and
                generate one draft PO per vendor. You review before
                releasing.
              </p>
              <div className="text-xs text-primary opacity-0 group-hover:opacity-100 transition pt-2">
                Start wizard →
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link
          to="/tools/fnb-po/pos/manual"
          data-testid="chooser-manual"
          className="group"
        >
          <Card className="hover:border-primary/60 hover:shadow-sm transition h-full">
            <CardContent className="pt-6 space-y-2">
              <div className="text-xs uppercase tracking-wider text-muted-foreground font-medium">
                Full control
              </div>
              <div className="text-lg font-semibold">Manual entry</div>
              <p className="text-sm text-muted-foreground">
                Blank draft. Pick vendor + destination + line items
                one at a time. Best for one-off orders or when the
                auto-suggestion doesn&apos;t fit.
              </p>
              <div className="text-xs text-primary opacity-0 group-hover:opacity-100 transition pt-2">
                Open blank draft →
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
